import React, { useEffect, useState } from "react";
import beautyOfJseon from "../../assets/images/website-images/beauty-of-jseon.png";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TabProduct from "./TabProduct";
import httpRequest from "src/helpers/httpRequest";
import {
  convertToKebabCase,
  getGridSizeData,
} from "src/helpers/helperFunctions";
import DotsLoaderAnimation from "../Loaders/DotsLoaderAnimation";
import { useNavigate } from "react-router-dom";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";

const DayAndNightTabImage =
  "https://images.ctfassets.net/zi25g2m16kts/68ilqtQWEp9WTaxT2cl0FX/a32b1aca458e6b868781a8452c12e505/codral-day-night-cold-flu-24-tablets-0-en-au";

const makupRemoverImage =
  "https://missrose.pk/cdn/shop/files/AH1I7777.jpg?v=1734589095&width=1946";

const facialMoisturizerImage =
  "https://zohaessentials.pk/wp-content/uploads/2023/09/CeraVe-PM-Facial-Moisturizing-Lotion.jpg";

const thermalWaterImage =
  "https://makeupmistress.pk/cdn/shop/files/la-roche-posay-thermal-spring-water-face-mist-facial-mist-face-spray-3433422404397-1.jpg?v=1711045083";

const LabTestHoveredTab = ({
  id,
  style,
  onClose,
  allTests,
  loader,
  setAllTests,
  setLoader,
}: {
  id: string;
  style: React.CSSProperties;
  onClose: () => void;
  allTests: any[];
  loader: boolean;
  setAllTests: (tests: any[]) => void;
  setLoader: (loader: boolean) => void;
}) => {
  const navigate = useNavigate();

  const { gridCols, totalDataLength } = getGridSizeData({
    rows: 3,
    extraLarge: 5,
    large: 5,
    medium: 4,
    small: 2,
  });

  const getAllTests = async () => {
    if (allTests.length === 0) {
      setLoader(true);
    }
    const { res, err } = await httpRequest<{ result: any[] }>({
      path: "/diagnostic-product/categories/all",
    });
    if (res) {
      let data = res.result;
      setAllTests(
        data.map((item) => ({
          name: item.name,
          id: item._id,
          image:  item.image,
        }))
      );
    }
    setLoader(false);
  };

  useEffect(() => {
    getAllTests();
  }, []);

  return (
    <div id={id} className="relative p-1 pt-0 h-fit min-h-[250px] xl:min-h-[300px] w-full">
      <div
        style={style}
        className="min-w-full p-2 2xl:p-4 rounded-br-md rounded-bl-md bg-white shadow relative"
      >
        <div className="flex justify-between items-end">
          <div>
            <h2 className="font-Lexend-SemiBold font-size-35px theme-color-green">
              Lab Tests
            </h2>
            <p className="font-size-18px font-Poppins-Regular under-dropdown-text">
              Explore all the Tests
            </p>
          </div>
          {allTests.length > totalDataLength && (
            <div
              className="font-size-16px font-Poppins-SemiBold theme-color-green-3f underline cursor-pointer"
              onClick={() => {
                onClose();
                navigate("/lab-tests");
              }}
            >
              View All
            </div>
          )}
        </div>
        <div
          className={`grid grid-cols-2 md:grid-cols-${gridCols} gap-2 xl:gap-3 2xl:gap-4 mt-3 xl:mt-4`}
        >
          {!loader ? (
            allTests.length > 0 ? (
              allTests.slice(0, totalDataLength).map((item, index) => (
                <TabProduct
                  id={`lab-test-${index}`}
                  key={"Product" + index}
                  data={item}
                  onClick={() => {
                    onClose();
                    navigate(
                      `/diagnostic-products?${QueryPath.labTestCategory}=${item.id}&${QueryPath.labTestCategoryName}=${encodeURIComponent(item.name)}`,
                    );
                  }}
                />
              ))
            ) : (
              <div className="flex w-full col-span-full justify-center items-center h-[150px]">
                <p className="font-size-18px font-Poppins-Regular theme-grey-type">
                  No Home Care Categories Found
                </p>
              </div>
            )
          ) : (
            <div className="flex w-full col-span-full justify-center items-center h-[150px]">
              <DotsLoaderAnimation />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LabTestHoveredTab;
